import { render, staticRenderFns } from "./ThemeSettingsDirectTop.vue?vue&type=template&id=51a745bc&scoped=true"
import script from "./ThemeSettingsDirectTop.vue?vue&type=script&lang=js"
export * from "./ThemeSettingsDirectTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a745bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a745bc')) {
      api.createRecord('51a745bc', component.options)
    } else {
      api.reload('51a745bc', component.options)
    }
    module.hot.accept("./ThemeSettingsDirectTop.vue?vue&type=template&id=51a745bc&scoped=true", function () {
      api.rerender('51a745bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/projects/themes/ThemeSettingsDirectTop.vue"
export default component.exports